import { render } from "./viewer.vue?vue&type=template&id=bacfb000&scoped=true"
import script from "./viewer.vue?vue&type=script&lang=js"
export * from "./viewer.vue?vue&type=script&lang=js"

import "./viewer.vue?vue&type=style&index=0&id=bacfb000&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bacfb000"

export default script